import useSWRImmutable from 'swr/immutable';
import { BASE_URI } from '@utils/configPublic';
import { SampleProjectsApi } from '@pages/api/project/sample';

export function useSampleProjects() {
  const url = `${BASE_URI}/api/project/sample`;
  const res = useSWRImmutable<SampleProjectsApi>(url);

  return res;
}
